
class NavegacaoInterna
{
	NavegacaoScroll()
	{
		const buttonTarget = $('#CCNavegacaoInterna.menuAncora li a');

		buttonTarget.each(function()
		{
			$(this).click(function(e)
			{
				e.preventDefault();

				let href = $(this).attr('href');
				let hash = '#'+href.split('#/')[1];
				let altura = $(hash).offset().top - 100;

				window.location = href;

				buttonTarget.removeClass('current-page-item');
				$(this).addClass('current-page-item');

				if(altura)
				{
					window.scroll({
						top: altura,
						behavior: 'smooth'
					});
				}
			});
		});
	}

	init(options)
	{
		const self = this;

		if ($("#CCNavegacaoInterna.menuAncora").length > 0)
    	{
			self.NavegacaoScroll();
		}
	}
}

export default NavegacaoInterna;